<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ProfessionalsIndex from './professionals/Index.vue';
import ServicesIndex from './services/Index.vue';
import PartnersIndex from './partners/Index.vue';

const { t } = useI18n();

const activeTab = ref('professionals');

const tabs = computed(() => [
  { key: 'professionals', label: t('APPOINTMENTS.TABS.PROFESSIONALS') },
  { key: 'services', label: t('APPOINTMENTS.TABS.SERVICES') },
  { key: 'partners', label: t('APPOINTMENTS.TABS.PARTNERS') },
]);
</script>

<template>
  <div class="flex flex-col flex-1 h-full overflow-hidden">
    <div class="px-6 pt-6 pb-0 border-b border-slate-200">
      <h1 class="text-2xl font-semibold text-slate-800 mb-4">
        {{ t('APPOINTMENTS.NAV.TITLE') }}
      </h1>
      <nav class="flex gap-1">
        <button
          v-for="tab in tabs"
          :key="tab.key"
          type="button"
          class="px-4 py-2 text-sm font-medium rounded-t-lg border-b-2 transition-colors"
          :class="[
            activeTab === tab.key
              ? 'border-blue-600 text-n-brand bg-n-blue-3'
              : 'border-transparent text-slate-600 hover:text-slate-800 hover:bg-slate-50',
          ]"
          @click="activeTab = tab.key"
        >
          {{ tab.label }}
        </button>
      </nav>
    </div>

    <div class="flex-1 overflow-hidden">
      <ProfessionalsIndex v-if="activeTab === 'professionals'" />
      <ServicesIndex v-else-if="activeTab === 'services'" />
      <PartnersIndex v-else-if="activeTab === 'partners'" />
    </div>
  </div>
</template>
